export const GARDEN_STYLES = [
  'Modern Garden',
  'Tropical Garden',
  'Mediterranean Courtyard',
  'Rustic Garden',
  'Japanese Zen Garden',
  'Minimalist Garden',
  'Luxury Villa Garden',
  'Urban Modern',
  'Classic Elegance',
  'Countryside Landscape',
  'Native Garden',
  'Waterfront Landscape',
  'Desert Landscape',
  'Rooftop Garden',
  'Family Backyard',
  'Poolside Landscape',
  'Commercial Landscape',
  'Showroom Display Garden',
];

export const GARDEN_STYLE_DEFAULT = 'Modern Garden';

export const GARDEN_CHANGE_LEVELS = [
  'Light Garden Refresh',
  'Balanced Redesign',
  'Full Garden Transformation',
];

export const GARDEN_CHANGE_LEVEL_DEFAULT = 'Balanced Redesign';

export const GARDEN_NATURAL_ELEMENTS = [
  'Flower',
  'Ground Cover',
  'Fruit Tree',
  'Climbers Plant',
  'Flowering Tree',
  'Undulating Terrain',
  'Hedge',
  'Ornamental Grass',
  'Lawn',
  'Flowering Shrub',
  'Shade Tree',
  'Flower Bed',
  'Rock',
  'Palm Tree',
  'Succulent Plants',
  'Bamboo',
  'Small Bushes',
  'Tall Trees',
  'Water Plants',
];

export const GARDEN_MAN_MADE_STRUCTURES = [
  'Corridor Shelter',
  'Swimming Pool',
  'Stone Retaining Wall',
  'Wooden Fence',
  'Mirror Pool',
  'Swing',
  'Slate Path',
  'Outdoor Furniture',
  'Stairs',
  'Concrete Path',
  'Pavilion',
  'Brick Path',
  'Garden Lights',
  'Iron Fence',
  'Fountain',
  'Pergola',
  'Fire Pit',
  'Outdoor Kitchen',
  'Decking',
  'Garden Bench',
  'Gazebo',
  'Stepping Stones',
  'Privacy Screen',
];

export const GARDEN_STYLES_SET = new Set(GARDEN_STYLES);
export const GARDEN_CHANGE_LEVELS_SET = new Set(GARDEN_CHANGE_LEVELS);
export const GARDEN_NATURAL_ELEMENTS_SET = new Set(GARDEN_NATURAL_ELEMENTS);
export const GARDEN_MAN_MADE_STRUCTURES_SET = new Set(GARDEN_MAN_MADE_STRUCTURES);

/**
 * @param {string[]} items
 * @param {number} [maxVisible]
 * @returns {string}
 */
export function formatGardenSelectionSummary(items, maxVisible = 3) {
  if (!Array.isArray(items) || items.length === 0) return 'AI Choice';
  const visible = items.slice(0, maxVisible);
  const summary = visible.join(', ');
  if (items.length > maxVisible) {
    return `${summary} +${items.length - maxVisible}`;
  }
  return summary;
}

/**
 * @param {unknown} raw
 * @param {Set<string>} allowed
 * @param {number} [maxItems]
 * @returns {string[]}
 */
export function sanitizeGardenStringList(raw, allowed, maxItems = 20) {
  if (!Array.isArray(raw)) return [];
  const seen = new Set();
  const result = [];
  for (const item of raw) {
    if (typeof item !== 'string') continue;
    const trimmed = item.trim();
    if (!trimmed || !allowed.has(trimmed) || seen.has(trimmed)) continue;
    seen.add(trimmed);
    result.push(trimmed);
    if (result.length >= maxItems) break;
  }
  return result;
}
